<template>
  <div>
    <div :class="['association-box']" :style="getIndentStyle(level)">
      <div
        v-if="item.subItems && item.subItems.length > 0"
        class="association-icon"
        @click.stop="handleIsShow(item)"
      >
        <i v-if="!item.isShow" class="el-icon-arrow-up" />
        <i v-if="item.isShow" class="el-icon-arrow-down" />
      </div>
      <div v-else style="width: 27px" />
      <img class="association-img" :src="item.icon" />
      <div class="association-title">
        <span style="cursor: pointer" @click.stop="handleClick(item)">{{
          item.barcodeNoPlus
        }}</span>
        <div v-if="item.state === '在库'">
          (<span style="color: #4076f2">{{ item.state }}</span
          >)
        </div>
        <div v-if="item.state === '离库'">
          (<span style="color: #ff1b1b">{{ item.state }}</span
          >)
        </div>
      </div>
      <div class="association-current" v-if="item.isCurrent">当前</div>
    </div>

    <div v-if="item.subItems && item.subItems.length > 0 && item.isShow">
      <Association
        v-for="v in item.subItems"
        :key="v.id"
        :item="v"
        :level="level + 1"
        @handleClick="handleClick"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Association",
  props: {
    item: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    getIndentStyle(level) {
      return {
        marginLeft: `${level * 20}px`,
      };
    },
    handleIsShow(value) {
      value.isShow = !value.isShow;
    },
    handleClick(value) {
      this.$emit("handleClick", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./association.scss";
</style>
